var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_102_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_106_",
    d: "M24.6,3.8H1.4C0.6,3.8,0,4.4,0,5.1v15.7c0,0.8,0.6,1.4,1.4,1.4h23.3c0.8,0,1.4-0.6,1.4-1.4V5.1 C26,4.4,25.4,3.8,24.6,3.8z M24.6,20.9H1.4V5.1h23.3V20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_110_",
    d: "M9.1,13.6l-5.9,4.9c-0.1,0.1-0.2,0.3,0,0.5l0.4,0.5c0.1,0.1,0.3,0.2,0.5,0l6.1-5.1l2.6,2.2 c0.1,0.1,0.3,0.1,0.4,0l2.7-2.3l6.2,5.2c0.1,0.1,0.4,0.1,0.5,0L23,19c0.1-0.1,0.1-0.4,0-0.5l-6-5l6-5.2c0.1-0.1,0.2-0.3,0-0.5 l-0.4-0.5c-0.1-0.1-0.3-0.2-0.5,0L13,15.1L3.9,7.3c-0.1-0.1-0.4-0.1-0.5,0L3,7.8C2.9,8,2.9,8.2,3,8.3L9.1,13.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.c487c1cebfb3180d981340e1cf456228.svg";
export { ForwardRef as ReactComponent };